import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'materialize-css/dist/js/materialize.min'
import message from '@/utils/message'
import Notifications from '@kyvg/vue3-notification'


const app = createApp(App).use(store).use(router).use(message).use(Notifications).mount('#app');
export default app;
//console.log(window.location.href);

